import React from 'react';
import { Button, Center, Text } from '@mantine/core';
import PaperSection from '../PaperSection';
import useCompletedSection from './useCompletedSection';
import EventItem from '../EventItem/EventItem';
import { getEndListText } from '../helpers';
import { EmptyList } from '../EmptyList';

const CompletedSection: React.FC = () => {
  const { loading, error, eventsToShow, moreEvents, showMore, events, extendForMonth } =
    useCompletedSection();

  return (
    <PaperSection loading={loading} title="COMPLETED EVENTS" error={error} mt="xl">
      {eventsToShow.length ? (
        <>
          {eventsToShow.map((event) => (
            <EventItem key={event.id} event={event} completed />
          ))}
          <Center p="md">
            {showMore ? (
              <Button variant="outline" onClick={moreEvents}>
                MORE
              </Button>
            ) : (
              <Text size="sm" c="dimmed" fw="bold">
                {getEndListText(events.length, extendForMonth)}
              </Text>
            )}
          </Center>
        </>
      ) : (
        <EmptyList text="You haven't had any events within the past month." />
      )}
    </PaperSection>
  );
};

export default CompletedSection;
